function getRandomNumber() {
  return Number(crypto.getRandomValues(new Uint32Array(1)));
}

export { getRandomNumber };
